import { NavLink } from 'react-router-dom';
import Logo from '../../images/logos/logo+icon_svg.svg?react';

export const NavbarSimple = () => {
  return (
    <nav className='flex w-full flex-row items-center justify-start bg-primary-dark p-6 md:px-10 lg:px-12'>
      <div className='flex h-12 flex-row flex-nowrap items-center justify-center gap-2'>
        <NavLink
          to={`/`}
          reloadDocument
          className='flex flex-row px-1 py-1'
        >
          <Logo />
        </NavLink>
      </div>
    </nav>
  );
};
